import { ReactNode } from "react";




// Pages Import



//// service page
import ServicePage from "./Pages/Service/Page";
import AddServicePage from "./Pages/Service/View/AddPage";
import EditService  from "./Pages/Service/View/EditPage";




//// Developer page
import DeveloperPage from "./Pages/Developer/Page";
import AddDeveloperPage from "./Pages/Developer/View/AddPage";
import EditDeveloper  from "./Pages/Developer/View/EditPage";


////  Project page
import ProjectPage from "./Pages/Project/Page";
import AddProjectPage from "./Pages/Project/View/AddPage";
import EditProject  from "./Pages/Project/View/EditPage";
import AddProjectImagePage from "./Pages/Project/ProjectImage/View/AddPage";



////  Key page
import KeyPage from "./Pages/Key/Page";
import AddKeyPage from "./Pages/Key/View/AddPage";
import EditKey  from "./Pages/Key/View/EditPage";



//// ContactUs page
import ContactUsPage from "./Pages/ContactUs/Page";

//// RequestQuotation page
import RequestQuotationPage from "./Pages/RequestQuotation/Page";


/// icons
import { FaServicestack } from "react-icons/fa";
import { ContactsOutlined, HomeFilled, ProjectFilled } from "@ant-design/icons";
import { MdDeveloperBoard } from "react-icons/md";
import { BsKey } from "react-icons/bs";
import HomePage from "./Pages/Home/HomePage";


interface RoutesLinksType {
    name?: string,
    href?: string,
    element?: ReactNode,
    icon?: any,
    Viewelement?: ReactNode,
    Viewhref?: string
    children?: any
    hidden?: boolean
}
export const RoutesLinks: RoutesLinksType[] = [


   
    {
        name: "Home",
        element:<HomePage/>,
        icon: <HomeFilled />,
        href: "/",
    },
    {
        name: "service",
        element: <ServicePage />,
        icon: <FaServicestack />,
        href: "/service",
    },
    {
        href: "/service/:id",
        element: <EditService />,
        hidden:true
    },
    {
        href: "/service/add",
        element: <AddServicePage />,
        hidden:true
    },
   
    {
        name: "Developer",
        element: <DeveloperPage />,
        icon: <MdDeveloperBoard />,
        href: "/developer",
    },
    {
        href: "/developer/:id",
        element: <EditDeveloper />,
        hidden:true
    },
    {
        href: "/developer/add",
        element: <AddDeveloperPage />,
        hidden:true
    },
    {
        name: "Project",
        element: <ProjectPage />,
        icon: <ProjectFilled />,
        href: "/project",
    },
    {
        href: "/project/:id",
        element: <EditProject />,
        hidden:true
    },
    {
        href: "/project/add",
        element: <AddProjectPage />,
        hidden:true
    },
    {
        href: "/project/:id/project_image/add",
        element: <AddProjectImagePage />,
        hidden:true
    },
    {
        name: "Key",
        element: <KeyPage />,
        icon: <BsKey />,
        href: "/key",
    },
    {
        href: "/key/:id",
        element: <EditKey />,
        hidden:true
    },
    {
        href: "/key/add",
        element: <AddKeyPage />,
        hidden:true
    },
    
    {
        name: "contact us",
        element: <ContactUsPage />,
        icon: <ContactsOutlined />,
        href: "/contact_us",
    },
    {
        name: "quotation",
        element: <RequestQuotationPage />,
        icon: <ContactsOutlined />,
        href: "/quotation",
    },
]